
import { Vue, Component, Ref } from "vue-property-decorator";
import { UserListDataSource } from "@/data/List/UserListDataSoure";
import RoleEditorDialog from "@/pages/manage/users/components/role-editor-dialog.vue";
import ResetPasswordDialog from "@/pages/manage/users/components/reset-password-dialog.vue";
import { UserObjectDataSource } from "@/data/Object/UserObjectDataSource";
import {mdiDownload, mdiPlus, mdiPlusCircleOutline, mdiUpload} from "@mdi/js";
import FileUploaderDialog from "@/components/helpers/file-uploader-dialog.vue";
import DataList from "@/components/common/data/list.vue";
import {ObjectDataSource} from "@/data/Object/ObjecDatatSource";
import {Filter} from "@/cms-services/filter";
import DataEditorDialog from "@/components/helpers/data/editor-dialog.vue";
import {ListDataSource} from "@/data/List/ListDataSource";
import {CompanyUserProfileObjectSource} from "@/data/Object/CompanyProfileObjectSource";
@Component({
  components: {DataEditorDialog, RoleEditorDialog, ResetPasswordDialog, FileUploaderDialog },
})
export default class UserList extends Vue {
  loaded:boolean = false;
  @Ref("dataEditor") dataEditor!: DataEditorDialog;

  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "companyProfile",
  });

  companyUserProfileSource:CompanyUserProfileObjectSource = new CompanyUserProfileObjectSource(+this.$route.params.id)

  companyUserProfileListSource :ListDataSource= new ListDataSource({
    className:"companyUserProfile",
    config:{ filter:JSON.stringify([
        new Filter("companyProfile", +this.$route.params.id)
      ]) }
  });

  usersDataSource :ListDataSource= new ListDataSource({
    className:"userProfile",
    config:{ filter:JSON.stringify([
        new Filter("excludeCompanyProfile", +this.$route.params.id)
      ]) }
  });

  get caption(): any {
    return this.dataSource.model?.caption;
  }

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Компании",
        to: "/manage/company-profile/",
        exact: true,
      },
      {
        text: this.dataSource.model?.caption,
        disabled: true,
      },
    ];
  }

  headers: Array<any> = [
    {
      text: "ID",
      value: "id",
      sortable: true,
      width: 100,
    },
    {
      text: "ФИО",
      value: "fullName",
      sortable: false,
    },
    {
      text: "Email",
      value: "email",
      sortable: false,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
    {
      text: "Дата создания",
      value: "createDate",
      sortable: false,
    },
  ];
  @Ref("dataList") dataList!: DataList;

  model: any = {
    profiles: [],
    emails: "",
    emailAddresses: [],
  };

  async add() {
    const model: any = await this.dataEditor.update(this.model);
    if (!model) return;
    try {
      model.emailAddresses = (model.emails??"").toLowerCase().split("\n");
      delete model.emails;
      const employees = await this.companyUserProfileSource.addEmployees(model);
      await (this.companyUserProfileListSource.get());
      this.usersDataSource.get();
      this.$message("Сотрудники добавлены");
    } catch (error: any) {
      console.log(error)
      this.$message(error.response.data, "error");
    }
  }


  $message: any;
  $confirm: any;
  icons: any = {
    circlePlus: mdiPlusCircleOutline,
    upload: mdiUpload,
    download: mdiDownload,
  };

  fields: any = [
    {
      editor: "auto-complete-select",
      attrs: {
        type: "text",
        outlined: true,
        label: "Выберите пользователя",
        noDataText: "Данные не найдены",
        multiple: true,
      },
      name: "profiles",
      config: {
        getItems: "getProfiles",
        labelKeyName: "fullName",
        valueKeyName: "id",
        type: "select",
      },
    },
    {
      name: "emails",
      editor: "memo",
      attrs: {
        outlined: true,
        label: "Введите список email адресов",
        hint: "Каждый email адрес должен начинаться с новой строки",
        persistentHint: true,
      },
    },
  ];

  fieldActions: any = {
    getProfiles: () => this.usersDataSource.items,
  };
  async created(){
    await Promise.all([  this.dataSource.get(),this.companyUserProfileListSource.get()]);
    this.loaded = true;

    this.usersDataSource.get()
  }


}
